import type { SVGProps } from "react";

const GovernanceLine = ({
  className,
  ...props
}: { className?: string } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="115"
      height="217"
      viewBox="0 0 115 217"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M113.333 216.333C113.886 216.333 114.333 215.886 114.333 215.333C114.333 214.781 113.886 214.333 113.333 214.333V215.333V216.333ZM80.8333 215.333V214.333V215.333ZM5.33337 5.33339L5.33338 6.33339L40.8333 6.3333L40.8333 5.3333V4.3333L5.33337 4.33339L5.33337 5.33339ZM60.8334 25.3333H59.8334V195.333H60.8334H61.8334V25.3333H60.8334ZM80.8333 215.333V216.333L113.333 216.333V215.333V214.333L80.8333 214.333V215.333ZM60.8334 195.333H59.8334C59.8334 206.931 69.2354 216.333 80.8333 216.333V215.333V214.333C70.3399 214.333 61.8334 205.827 61.8334 195.333H60.8334ZM40.8333 5.3333L40.8333 6.3333C51.3268 6.33328 59.8334 14.8399 59.8334 25.3333H60.8334H61.8334C61.8334 13.7353 52.4313 4.33327 40.8333 4.3333V5.3333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default GovernanceLine;
